/**
 * MICHIDART Logo
 * tone: 'navy' (深色背景用白色) | 'white' (淺色背景用深色) — 預設 'white'
 * height: px 高度
 */
function Logo({ height = 40, tone = 'white' }) {
  const src = tone === 'navy'
    ? `${process.env.PUBLIC_URL}/assets/logo-michidart-white.svg`
    : `${process.env.PUBLIC_URL}/assets/logo-michidart-navy.svg`;
  return (
    <img
      src={src}
      alt="MICHIDART"
      height={height}
      style={{ display: 'block', width: 'auto' }}
    />
  );
}

export default Logo;
